import { render, staticRenderFns } from "./DeleteDatabaseModal.vue?vue&type=template&id=2e9403c2&"
import script from "./DeleteDatabaseModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDatabaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9403c2')) {
      api.createRecord('2e9403c2', component.options)
    } else {
      api.reload('2e9403c2', component.options)
    }
    module.hot.accept("./DeleteDatabaseModal.vue?vue&type=template&id=2e9403c2&", function () {
      api.rerender('2e9403c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Databases/DeleteDatabaseModal.vue"
export default component.exports